// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"1c850048","81":"ce21cb07","236":"d6b0c284","338":"b84a38cb","342":"66186c41","375":"bf3f42ec","381":"debf97de","420":"004903f6","549":"84473d35","681":"a27cac67"}[chunkId] + ".chunk.css";
};